import { transaction } from "./transaction";
import { transactionChart } from "./transactionChart";
import { transactionById } from "./transactionById";
import { banks } from "./banks";
import { getAvailableCredit } from "./getAvailableCredit";
import { createTransaction } from "./createTransaction";
import { requestWithdraw } from "./requestWithdraw";
import { attachmentsType } from "./attachmentsType";
import { uploadAttachment } from "./uploadAttachment";
import { getCommission } from "./getCommission";
import { editTransaction } from "./edit";
import { checkCpf } from "./checkCpf";

export const transactionsService = {
  transaction,
  transactionChart,
  transactionById,
  banks,
  getAvailableCredit,
  createTransaction,
  requestWithdraw,
  attachmentsType,
  uploadAttachment,
  getCommission,
  editTransaction,
  checkCpf,
};
